import { GasV3Integration as BaseGasV3Integration, SentryBrowserIntegration as BaseSentryBrowserIntegration } from '@atlassian/commerce-telemetry/integrations';
import { withSafeGuard } from './telemetry-version-safe-guard';
export var GasV3Integration = withSafeGuard(BaseGasV3Integration);
export var SentryBrowserIntegration = withSafeGuard(BaseSentryBrowserIntegration);